import script from "./TableBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TableBox.vue?vue&type=script&setup=true&lang=js"

import "./TableBox.vue?vue&type=style&index=0&id=3cdb8a8c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cdb8a8c"]])

export default __exports__